import axios from "axios";

const BASE_URL = process.env.REACT_APP_GS1_BASE_URL;

export const gs1_api = axios.create({
	baseURL: BASE_URL,
});

export const userLogin = async (data) => {
	const response = await gs1_api.post("/gs1/standard/user/login", data, {
		headers: {
			"content-type": "application/json",
		},
	});
	return response;
};

export const userForgotPassword = async (data) => {
	const response = await gs1_api.post("/gs1/standard/user/forgot-password", data, {
		headers: {
			"content-type": "application/json",
		},
	});
	return response;
};

export const userResetPassword = async (data) => {
	const response = await gs1_api.post(
		"/gs1/standard/user/reset-password",
		data,
		{
			headers: {
				"content-type": "application/json",
			},
		},
	);
	return response;
};

export const commissionPackage = async (data, token) => {
	const response = await gs1_api.post("/label/commission", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const decommissionPackage = async (data, token) => {
	const response = await gs1_api.post("/decommission", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const packPackage = async (data, token) => {
	const response = await gs1_api.post("/label/pack ", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const unpackPackageContent = async (data, token) => {
	const response = await gs1_api.post("/label/unpack ", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const allLocation = async (token) => {
	const response = await gs1_api.get("/locations", {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const shipping = async (data, token) => {
	const response = await gs1_api.post("/label/ship", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const dispensing = async (data, token) => {
	const response = await gs1_api.post("/label/dispense", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const receiving = async (data, token) => {
	const response = await gs1_api.post("/label/receive", data, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});

	return response;
};

export const getPackContent = async (data, token) => {
	const response = await gs1_api.get(`label/pack/volume/${data}`, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const getAllClients = async (token, controller) => {
	JSON.parse(sessionStorage.getItem("userClients"));
	const response = await gs1_api.get(
		`client/?clients=${JSON.parse(sessionStorage.getItem("userClients"))}`,
		{
			signal: controller.sigbal,
			headers: {
				"content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		},
	);
	return response;
};

export const getlocationbyKey = async (token, key) => {
	const response = await gs1_api.get(`client/location/${key.clientKey}`, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const getProductsbyKey = async (token, key) => {
	const response = await gs1_api.get(`client/products/${key.clientKey}`, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const getPackSize = async (token, prodId) => {
	const response = await gs1_api.get(`packSize/?prodId=${prodId}`, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const fetchPartnersByclientId = async (token, data) => {
	const response = await gs1_api.get(`/client/tradepartner/${data}`, {
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});
	return response;
};

export const axiosPrivate = axios.create({
	baseURL: BASE_URL,
});
